import { Navigate } from "react-router";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
    const token = useSelector((state) => state.User.interviewId);

    if (token) {
        return children;
    }

    return (
        <Navigate to="/interview-link" />
    )
}

export default PrivateRoute;